import { useWorkflowEditorContext } from "components/WorkflowEditor/WorkflowEditorProvider/WorkflowEditorProvider";
import {
  PanelWorkflowOutputList,
  PanelWorkflowOutputListProps,
} from "./PanelWorkflowOutputList";

export const WorkflowEditorPageOutputs = () => {
  const outputs = useWorkflowEditorContext((s) =>
    s.results.map<PanelWorkflowOutputListProps["outputs"][number]>((res) => {
      const overrides = s.resultOverrides[res.id];
      return {
        id: res.id,
        key: res.key,
        name: res.name,

        tableName: s.tableInfoOverrides[res.tableId].name,
        outputPolicy: overrides.outputPolicy,
        description: overrides.description,
      };
    }),
  );
  return <PanelWorkflowOutputList outputs={outputs} />;
};
